import {
    CLEAR_PERSONAL_DAILY_REPORT,
    CLEAR_LOADING,
    FETCH_PERSONAL_DAILY_REPORT,
    LIST_PERSONAL_DAILY_REPORT,
} from "./types";

const init = {
    isLoading: false,
    data: null,
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_PERSONAL_DAILY_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_PERSONAL_DAILY_REPORT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_PERSONAL_DAILY_REPORT:
            return {
                ...init
            };
        case CLEAR_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}